import { createContext } from 'react';

const DocumentosComercio = createContext();

export default DocumentosComercio;
